import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiBarChartComponent } from '@components';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        UiBarChartComponent,
    ],
    exports: [
        UiBarChartComponent,
    ],
})
export class UiBarChartModule { }
